var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.25C7.44891 14.25 7.63968 14.329 7.78033 14.4697C7.92098 14.6103 8 14.8011 8 15C8 15.1989 7.92098 15.3897 7.78033 15.5303C7.63968 15.671 7.44891 15.75 7.25 15.75H2.75C2.55109 15.75 2.36032 15.671 2.21967 15.5303C2.07902 15.3897 2 15.1989 2 15C2 14.8011 2.07902 14.6103 2.21967 14.4697C2.36032 14.329 2.55109 14.25 2.75 14.25H7.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7803 9.96967C13.6397 9.82902 13.4489 9.75 13.25 9.75H2.75C2.55109 9.75 2.36032 9.82902 2.21967 9.96967C2.07902 10.1103 2 10.3011 2 10.5C2 10.6989 2.07902 10.8897 2.21967 11.0303C2.36032 11.171 2.55109 11.25 2.75 11.25H13.25C13.4489 11.25 13.6397 11.171 13.7803 11.0303C13.921 10.8897 14 10.6989 14 10.5C14 10.3011 13.921 10.1103 13.7803 9.96967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 5.25C17.9489 5.25 18.1397 5.32902 18.2803 5.46967C18.421 5.61032 18.5 5.80109 18.5 6C18.5 6.19891 18.421 6.38968 18.2803 6.53033C18.1397 6.67098 17.9489 6.75 17.75 6.75H2.75C2.55109 6.75 2.36032 6.67098 2.21967 6.53033C2.07902 6.38968 2 6.19891 2 6C2 5.80109 2.07902 5.61032 2.21967 5.46967C2.36032 5.32902 2.55109 5.25 2.75 5.25H17.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.fdc7dcbb002c30fcab25e74a6b8b57cc.svg";
export { ForwardRef as ReactComponent };